// extracted by mini-css-extract-plugin
export var alertCards = "_6-0";
export var card = "_6-1";
export var fade = "_6-2";
export var hidden = "_6-3";
export var progressBar = "_6-4";
export var roundtime = "_6-5";